import axios from "axios"
import { APIURL } from "../Constantes"
import { getCabecera } from "../utils/getCabecera"
import { getError } from "../utils/errors"

const urlInvoice = "Invoice"

//* Obtener todos las solicitudes de factura pendientes agente
//* GET /api/Invoice/Pending/{Referencia}/{Pagina}/{Registros}
export const getSolicitudFacturasPendientesAll = async ({ Referencia, Pagina, Registros }) => {
    return axios.get(`${APIURL}/${urlInvoice}/Pending/${Referencia}/${Pagina}/${Registros}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return [];
        })
}
//* Validar una informacion de facturacion pendiente agente
//* PUT /api/Invoice/Validate/{IdFactura}
export const putValidateSolicitudFactura = async ({ IdFactura }) => {
    return axios.put(`${APIURL}/${urlInvoice}/Validate/${IdFactura}`,
        {

        },
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data
        }).catch((Error) => {
            return getError(Error)
        })
}
//* Obtener todas las facturas validas finanzas
//* GET /api/Invoice/Validate/{Referencia}/{Pagina}/{Registros}
export const getSolicitudFacturasValidasAll = async ({ Referencia, Pagina, Registros }) => {
    return axios.get(`${APIURL}/${urlInvoice}/Validate/${Referencia}/${Pagina}/${Registros}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return [];
        })
}
//* Aceptar solicitud de facturacion valida finanzas
//* PUT /api/Invoice/Accept/{IdFactura}
export const putAceptarFactura = async ({ IdFactura }) => {
    return axios.put(`${APIURL}/${urlInvoice}/Accept/${IdFactura}`,
        {
        },
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data
        }).catch((Error) => {
            return getError(Error)
        })
}
//* Consultar historico de las facturas aceptadas
//* GET /api/Invoice/{Referencia}/{IdCatEstatusDevolucion}/{Pagina}/{Registros}
export const getFacturasAceptadasHistoricoAll = async ({ Referencia, Pagina, Registros, IdCatEstatusDevolucion }) => {
    return axios.get(`${APIURL}/${urlInvoice}/${Referencia}/${IdCatEstatusDevolucion}/${Pagina}/${Registros}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return [];
        })
}
//* Declinar la solictud por parte de finanzas
//* PUT /api/Invoice/Decline/Finance/{IdDevolucionSolicitud - Finanzas
export const putDeclinarSolitudFacturaFinanzas = async ({IdFactura}) => {
    return axios.put(`${APIURL}/${urlInvoice}/Decline/Finance/${IdFactura}`,
    {
    },
    {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        return getError(Error)
    })
}
//* Declinar la solictud por parte de agente
//* PUT /api/Invoice/Decline/Agent/{IdDevolucionSolicitud} - Agente
export const putDeclinarSolitudFacturaAgente = async ({IdFactura}) => {
    return axios.put(`${APIURL}/${urlInvoice}/Decline/Agent/${IdFactura}`,
    {
    },
    {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        return getError(Error)
    })
}